import 'bootstrap';
import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/es';
import numeral from 'numeral';
import numeralLocale from 'numeral/locales/es';
import 'moment/locale/es';
import VueTippy from 'vue-tippy';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

import store from './Store/store';

import ExploreVisualization from './Components/Visualizations/Explore';
import CompareVisualization from './Components/Visualizations/Compare';
import ExpensesVisualization from './Components/Visualizations/Expenses';
import ProvidersVisualization from './Components/Visualizations/Providers';
import ProvidersRankingVisualization from './Components/Visualizations/ProvidersRanking';
import ProviderSankeyVisualization from './Components/Visualizations/ProviderSankey';
import ProgressVisualization from './Components/Visualizations/Progress';
import PeopleVisualization from './Components/Visualizations/People';
import PayDragVisualization from './Components/Visualizations/PayDrag';
import SectorsVisualization from './Components/Visualizations/Sectors';
import PaymentDaysVisualization from './Components/Visualizations/PaymentDays';
import StatesVisualization from './Components/Visualizations/States';
import ProgressPieVisualization from './Components/Visualizations/ProgressPie';
import GlobalInfoVisualization from './Components/Visualizations/GlobalInfo';
import InstitutionsStatusVisualization from './Components/Visualizations/InstitutionsStatus';
import CompareForm from './Components/Forms/Compare';
import ContactForm from './Components/Forms/Contact';
import HomeSectors from './Components/HomeSectors';
import StatesTable from './Components/Visualizations/StatesTable';
import GraphReadInstructions from './Components/GraphReadInstructions';

if (process.env.MIX_BUGSNAG_API_KEY) {
    const bugsnagClient = bugsnag(process.env.MIX_BUGSNAG_API_KEY);
    bugsnagClient.use(bugsnagVue, Vue);
}

Vue.use(VueTippy);
Vue.use(ElementUI, { locale });
numeral.locale('es', numeralLocale);

/*
window.config = {
    defaultYear: 1 * process.env.MIX_DEFAULT_YEAR,
    updatedAt: moment(process.env.MIX_UPDATED_AT).toDate()
};
*/

new Vue({
    el: '#app',
    components: {
        ExploreVisualization,
        CompareVisualization,
        ExpensesVisualization,
        ProvidersVisualization,
        ProgressVisualization,
        PeopleVisualization,
        CompareForm,
        ProvidersRankingVisualization,
        ProviderSankeyVisualization,
        PayDragVisualization,
        SectorsVisualization,
        PaymentDaysVisualization,
        ContactForm,
        ProgressPieVisualization,
        StatesVisualization,
        GlobalInfoVisualization,
        HomeSectors,
        StatesTable,
        InstitutionsStatusVisualization,
        GraphReadInstructions
    },
    store
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js